import { MenuItem, PrimeIcons } from "primeng/api";
import { AbstractMenuModule } from "./menu/abstract-menu-module";
import { CargoFeaturesModel, AuthUserModel, ClientInfoModel } from "./model";
import { Router } from "@angular/router";
import { AuthService } from "./auth/auth.service";

const _menuItems: MenuItem[] = [
  {
    id: 'user',
    label: 'Пользователь',
    icon: PrimeIcons.USER,
    items: [
      {
        id: 'registerInfo',
        label: 'Регистрационные данные',
        icon: PrimeIcons.USER_EDIT,
        routerLink: 'register-info'
      },
      {
        id: 'resetPasswd',
        label: 'Восстановление пароля',
        icon: PrimeIcons.KEY,
        routerLink: 'reset-passwd'
      },
      {
        id: 'changePasswd',
        label: 'Сменить пароль',
        icon: PrimeIcons.SHIELD,
        routerLink: 'change-passwd'
      },
      {
        id: 'appLoginSep',
        separator: true
      },
      {
        id: 'appLogin',
        label: 'Мобильное приложение',
        icon: PrimeIcons.QRCODE,
        routerLink: 'app-login'
      },
      {
        id: 'cargoInfo',
        label: 'Информация о карго',
        icon: PrimeIcons.INFO_CIRCLE,
        routerLink: 'cargo-info'
      },
      {
        id: 'registerSep',
        separator: true
      },
      {
        id: 'register',
        label: 'Регистрация в системе',
        icon: PrimeIcons.USER_PLUS,
        routerLink: 'register'
      },
      { separator: true },
      {
        id: 'login',
        label: 'Вход в систему',
        icon: PrimeIcons.SIGN_IN,
        routerLink: 'login',
      },
      {
        id: 'logout',
        label: 'Выход из системы',
        icon: PrimeIcons.POWER_OFF,
      },
    ],
  }
]

export class AppMenu extends AbstractMenuModule {
  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  override checkUserRole(roleName?: string): boolean {
    return true;
  }

  override buildMenu(user?: ClientInfoModel, auth?: AuthUserModel, features?: CargoFeaturesModel): MenuItem[] {
    const menuItems = this.copyMenuItems(_menuItems);

    menuItems.forEach((item: MenuItem) => {
      switch (item.id) {
        case 'user':
          // add username into user menu    
          if (user) {
            item.label += ` (${user.first_name} ${user.last_name})`;
          }

          // process other user subitems
          item.items?.forEach((userItem: MenuItem) => {
            switch (userItem.id) {
              case 'login':
                userItem.visible = !user;
                break;
              case 'logout':
                userItem.visible = user !== undefined;
                userItem.command = (event) => this.logout();
                break;
              case 'registerInfo':
                userItem.visible = user !== undefined && auth?.userRole === 'customer';
                break;
              case 'resetPasswd':
                userItem.visible = !user;
                break;
              case 'changePasswd':
                userItem.visible = user !== undefined && auth?.userRole !== 'storage';
                break;
              case 'appLogin':
              case 'appLoginSep':
                userItem.visible = user !== undefined && features?.isMobileApp === true;
                break;
              case 'register':
              case 'registerSep':
                userItem.visible =
                  (!features?.isNewUserAdminRequired && !user) ||
                  (features?.isNewUserAdminRequired === true && auth?.userRole === 'admin');
                break;
              case 'cargoInfo':
                userItem.visible = user !== undefined && features?.isCargoInfo === true;
                break;
            }
          });
          break;
      }
    });

    return menuItems;
  }

  async logout() {
    await this.authService.logout();
    this.router.navigate(['/']);
  }

}